<template>
  <div>
    <!-- 搜索 -->
    <el-row style="">
      <el-col :span="24">
        <el-col
          :span="8"
          style="
            display: block;
            text-align: right;
            line-height: 40px;
            padding: 0 20px;
          "
        >
          <!-- 个人用户 -->
          <span class="systemFont1">个人用户</span>
        </el-col>
        <el-col :span="8">
          <el-col :span="24"
            ><el-input
              v-model="queryInput"
              :placeholder="$t('p0323.text1')"
            ></el-input
          ></el-col>
        </el-col>
        <el-col
          :span="8"
          style="display: block; text-align: left; padding: 0 20px"
        >
          <img
            src="../../assets/p0322Query.svg"
            width="36px"
            height="36px"
            style="cursor: pointer"
            @click="findStudents(true)"
          />
        </el-col>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row style="margin-top: 20px">
      <el-col :span="24">
        <el-table
          ref="findStudentsTable"
          :data="findStudentsData"
          v-loading="tableLoading"
          tooltip-effect="dark"
          style="width: 100%"
          :row-key="getRowKeys"
          @select="selectItem"
          @select-all="selectAll"
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            :selectable="selected"
            min-width="10"
          >
          </el-table-column>
          <!-- 头像 -->
          <el-table-column :label="$t('p0323.avatar')" min-width="6">
            <template slot-scope="scope"
              ><el-avatar
                style="display: flex"
                :src="
                  scope.row.headPortrait == null
                    ? defaultImg
                    : 'data:image/png;base64,' + scope.row.headPortrait
                "
                :size="30"
              ></el-avatar
            ></template>
          </el-table-column>
          <!-- 姓名 -->
          <el-table-column :label="$t('p0323.name')" min-width="10">
            <template slot-scope="scope">{{
              scope.row.lastName +" "+ scope.row.firstName
            }}</template>
          </el-table-column>
          <!-- 英文姓名 -->
          <el-table-column
            prop="name"
            :label="$t('p0323.englishName')"
            min-width="10"
          >
            <template slot-scope="scope">{{
              scope.row.lastNameEn == null && scope.row.firstNameEn == null
                ? ""
                : scope.row.lastNameEn +" "+ scope.row.firstNameEn
            }}</template>
          </el-table-column>
          <!-- 昵称 -->
          <el-table-column
            prop="nickname"
            :label="$t('p0323.nickName')"
            min-width="6"
          >
          </el-table-column>
          <!-- 邮箱 -->
          <el-table-column
            prop="email"
            :label="$t('p0323.mail')"
            min-width="15"
          >
          </el-table-column>
          <!-- 手机号码 -->
          <el-table-column
            prop="name"
            :label="$t('p0323.cellphoneNumber')"
            min-width="10"
          >
            <template slot-scope="scope">{{
              scope.row.phoneArea + scope.row.phoneNo !== 0
                ? scope.row.phoneArea + scope.row.phoneNo
                : ""
            }}</template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 分页 -->
    <el-row style="text-align: center; margin-top: 10px">
      <el-col :span="24">
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="sizes, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <!-- 提交 -->
    <el-row style="text-align: center; margin: 20px">
      <el-col :span="24">
        <el-button type="submit" @click="addStudents">{{
          $t("p0323.submit")
        }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    p0322Input: {
      type: Object,
      required: true
    },
    closeDialog: {
      type: Function,
      default: null
    },
    selectInviteStudents: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      tableLoading: false,
      //查询输入框
      queryInput: "",
      // 表格数据
      findStudentsData: [],
      currentPage: 1,
      pageSize: 10,
      tblScheduleStudents: [],
      total: 0,
      // 默认头像图片
      defaultImg: require("../../assets/headPortrait.png"),
      tmpQueryStr: ""
    };
  },
  methods: {
    //选中单列
    selectItem(list, row) {
      this.tblScheduleStudents = list;
    },
    //全选
    selectAll(selection) {
      // 若取消全选，当前页的选中数据移除
      if (selection.length === 0) {
        const ids = this.findStudentsData.map(i => {
          return i.userId;
        });
        for (var i = 0; i < this.tblScheduleStudents.length; i++) {
          if (ids.indexOf(this.tblScheduleStudents[i].id) > -1) {
            this.tblScheduleStudents.splice(i, 1);
            i--;
          }
        }
      }
      const arr = [...selection, ...this.tblScheduleStudents];
      this.tblScheduleStudents = Array.from(new Set(arr));
    },
    //进入p0323
    openP0323() {
      //清空查询内容
      this.$refs.findStudentsTable.clearSelection();
      this.tblScheduleStudents = [];
      this.findStudentsData = [];
      this.total = 0;
      this.currentPage = 1;
      this.queryInput = "";
      this.findStudents();
    },
    //添加学员
    addStudents() {
      // this.tblScheduleStudents = this.$refs.findStudentsTable.selection;
      if (this.tblScheduleStudents.length === 0) {
        // 未选择学员
        this.$message.error(this.$t("p0323.noStudentSelected"));
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector(".roll-dialog")
      });
      let url = "/api/classInvitation/insertAddStudents";
      this.$http
        .post(url, {
          field: this.p0322Input.field,
          category: this.p0322Input.category,
          courseNumber: this.p0322Input.courseNumber,
          dateAndTime: moment(this.p0322Input.dateAndTime).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          userId: localStorage.getItem("userId"),
          classInvitationVos: this.tblScheduleStudents
        })
        .then(response => {
          loading.close();
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            //添加成功
            this.$message.success(this.$t("p0323.addedSuccessfully"));
            this.closeDialog();
            this.selectInviteStudents();
            this.$refs.findStudentsTable.clearSelection();
            this.findStudentsData = [];
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          loading.close();
          this.$message.error(err);
        });
    },
    selected(row, index) {
      if (row.invitationStatus == 1) {
        //可选择
        return false;
      } else {
        //不可选择
        return true;
      }
    },

    getRowKeys(row) {
      return row.userId;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      //判断更改页码是否需要查询
      if (
        this.findStudentsData == undefined ||
        this.findStudentsData.length <= 0
      ) {
        return;
      }
      this.findStudents();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.findStudents();
      console.log(`当前页: ${val}`);
    },
    // 查找学生
    findStudents(val) {
      //判断搜索
      if (val) {
        this.$refs.findStudentsTable.clearSelection();
        this.tblScheduleStudents = [];
        this.currentPage = 1;
        this.tmpQueryStr = this.queryInput;
      }
      this.queryInput = this.tmpQueryStr;
      this.tableLoading = true;
      let url = "/api/classInvitation/selectAddStudents";
      this.queryInput;
      this.$http
        .post(url, {
          field: this.p0322Input.field,
          category: this.p0322Input.category,
          courseNumber: this.p0322Input.courseNumber,
          dateAndTime: moment(this.p0322Input.dateAndTime).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          queryInput: this.queryInput,
          currentPage: (this.currentPage - 1) * this.pageSize,
          pageSize: this.pageSize,
          total: this.total
        })
        .then(response => {
          this.tableLoading = false;
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            //判断是否初始化
            if (this.currentPage == 1) {
              this.findStudentsData = response.data.data;
              if (this.findStudentsData.length > 0) {
                this.total = this.findStudentsData[0].total;
              } else {
                this.total = 0;
              }
            } else {
              this.findStudentsData = response.data.data;
            }
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          this.tableLoading = false;
          this.$message.error(err);
        });
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
// 表格样式
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
  padding: 8.5px 0;
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/views/GreenJacketForum/P0323.vue